import styled, { css } from 'styled-components';
import { inputStyles } from '../../styled/inputs';

export const StyledInput = styled.input`
  ${inputStyles};

  ${({ $error, theme }) =>
    $error &&
    css`
      border: 4px solid ${theme.palette.errorBorder};
      background-color: ${theme.palette.errorBackground};
      padding: 8px 6px 7px;

      &:focus,
      &:active {
        padding: 8px 6px 7px;
        background-color: ${theme.palette.white};
      }
    `}

  width: 100%;

  ${({ $short }) =>
    $short &&
    css`
      min-width: 160px;
      width: 33%;
    `};
`;
